import { AccountFeatureFlags } from './account';
import { CashierFeatureFlags } from './cashier';
import { CasinoFeatureFlags } from './casino';
import { HelpCenterFeatureFlags } from './help';
import { MartechFeatureFlags } from './martech';
import { WebPlatformFeatureFlags } from './platform';
import { PokerFeatureFlags } from './poker';
import { SharedFeatureFlags } from './shared';
import { SpadeFeatureFlags } from './spade';
import { SportsFeatureFlags } from './sports';

export const FeatureFlag = {
  ...AccountFeatureFlags,
  ...CashierFeatureFlags,
  ...CasinoFeatureFlags,
  ...HelpCenterFeatureFlags,
  ...MartechFeatureFlags,
  ...PokerFeatureFlags,
  ...SharedFeatureFlags,
  ...SpadeFeatureFlags,
  ...SportsFeatureFlags,
  ...WebPlatformFeatureFlags
} as const;

export enum FeatureFlagParam {
  MinLtVpp = 'min-lt-vpp'
}

export type FeatureFlag = (typeof FeatureFlag)[keyof typeof FeatureFlag];
